import styled from 'styled-components';

import { COLORS, ANIM, SPACE } from '../../../../theme/tokens';
import { cardEnterAt, hoverWash } from '../../../../theme/mixins';
import { Divider, Text } from '../../../../components';

/** The row's icon tile, on the Website and Marketing hub tiles' recipe: a 44px neutral tile holding a 24px glyph. */
const TILE_PX = 44;
const TILE_RADIUS_PX = 11;
export const ICON_PX = 24;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

/** The fading hairline between two groups of rows (Secure your brand, the brand-level sections, the account-level
 *  ones): a touch more room than the inter-row gap, so it reads as a deliberate break. It enters with the first row
 *  of the group it opens. */
export const GroupDivider = styled(Divider)<{ $enterIndex: number }>`
  margin: ${SPACE[4]} ${SPACE[0]};
  ${(p) => cardEnterAt(p.$enterIndex)}
`;

/** One section's row. As the index shows, the rows fade and rise in one after another, on the Website and Marketing
 *  hub cards' entrance and stagger: the n-th row starts n stagger steps after the first. */
export const Row = styled.button<{ $enterIndex: number }>`
  ${(p) => cardEnterAt(p.$enterIndex)}
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACE[16]};
  width: 100%;
  height: 64px;
  padding: ${SPACE[0]} ${SPACE[20]};
  border: 1px solid ${COLORS.panelBorder};
  border-radius: 16px;
  background: ${COLORS.surfaceCard};
  cursor: pointer;
  transition: border-color ${ANIM.INTERACT_MS}ms ease;
  ${hoverWash}

  &:hover {
    border-color: ${COLORS.ctaBorder};
  }

  /* The arrow keeps its size; a long name shortens instead. */
  & > svg {
    flex: none;
  }
`;

/** The tile and, beside it, the section's name. */
export const Lead = styled.span`
  display: flex;
  align-items: center;
  gap: ${SPACE[16]};
  min-width: 0;
`;

/** The icon tile: a neutral surface; the glyph carries the row's hue. */
export const Tile = styled.span`
  flex: 0 0 auto;
  width: ${TILE_PX}px;
  height: ${TILE_PX}px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${TILE_RADIUS_PX}px;
  background: ${COLORS.surfaceMuted};
`;

/** A long name (a long brand name, or a narrow phone) wraps to a second line rather than being cut; two lines of it
 *  still fit the row's 64px beside the tile. */
export const RowLabel = styled(Text)`
  min-width: 0;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  overflow-wrap: anywhere;
  text-align: left;
  line-height: 1.2;
  font-size: 18px;
  font-weight: 600;
  color: ${COLORS.featureName};
`;
